import { Component, Input, OnInit } from "@angular/core";
import { WebTransaction } from "../../../models";
import { ExcelService } from "../../../services/excel-service";
import { PdfService } from "../../../services/pdf.service";
import { SessionDataService } from "src/app/services/session-data.service";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-export-data",
    templateUrl: "./export-data.component.html",
    styleUrls: ["./export-data.component.scss"],
})

export class ExportDataComponent implements OnInit
{

    @Input() transactionList: WebTransaction[];
    @Input() isPayment: boolean;
    @Input() showToolTip: boolean;
    header: any[];
    isEmployee: boolean;


    constructor(
        private excelService: ExcelService,
        private pdfService: PdfService,
        private sessionDataService: SessionDataService,
        private date: DatePipe,
    ) { }

    ngOnInit(): void
    {
        this.isEmployee = this.sessionDataService.IsEmployee
    }

    exportAsXLSX(transaction: WebTransaction[]): void
    {
        const myTransactions = this.transactionsToArray(transaction);
        if (this.isPayment)
        {
            this.excelService.exportPayment(myTransactions, "transactions");
        } 
        else
        {
            this.excelService.exportTransaction(myTransactions, "transactions");
        }
    }

    exportAsPdf(transaction: WebTransaction[]): void
    {
        const myTransactions = this.transactionsToArray(transaction);
        if (this.isPayment)
        {
            this.pdfService.exportPaymentPdf(myTransactions);
        } 
        else
        {
            this.pdfService.exportTransactionPdf(myTransactions);
        }
    }

    transactionsToArray(transactions: any): any[]
    {
        const rows = [];
        const transList = [transactions];
        transList.forEach(element =>
        {
            element.forEach(trans =>
            {
                if (trans.Tran === "N")
                {
                    return
                }
                let temp;
                if (!this.isPayment)
                {
                    temp = [
                        this.date.transform(trans.Date, "MM/dd/yyyy"),
                        trans.RefNo,
                        trans.Desc,
                        trans.Type,
                        trans.Loc.toString(),
                        trans.SaleType,
                        trans.Qty,
                        trans.UnitPrice,
                        trans.PriceTotal,
                    ];
                } 
                else
                {
                    temp = [
                        this.date.transform(trans.Date, "MM/dd/yyyy"),
                        trans.RefNo,
                        trans.Type,
                        trans.CheckNo,
                        trans.PriceTotal,
                    ];
                }
                rows.push(temp);
            });
        });
        return rows;
    }
}

